module.exports = __webpack_public_path__ + "img/business_model_list2.c3eea31f.png";